import { TASK_LIST_REQUESTED,
         TASK_LIST_RECEIVED,
         TASK_LIST_ERROR,
    
         } from "../actions/bpmnTaskList";
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
 *
 * @param {RequestResult} state
 * @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
 * @return {RequestResult}
 */
export const taskList = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

    switch (action.type) {
        case TASK_LIST_REQUESTED:
            return new RequestResult(RequestState.getInstanceLoading(), state.data);
        case TASK_LIST_RECEIVED:
            return new RequestResult(RequestState.getInstanceDone(), action.taskList, action.receivedAt);
        case TASK_LIST_ERROR:
            return new RequestResult(
                RequestState.getInstanceError(
                    action.errorResponseStatusCode,
                    action.errorResponseMessage ? action.errorResponseMessage : null
                ),
                state.getData()
            );
      
        default:
            return state
    }
};
